import { LANGUAGE_STORAGE_KEY } from '../core/i18n/preferred-language';
import type { Language } from '../core/i18n/language';

/**
 * The visitor's remembered language choice.
 *
 * Kept under the key the live static site already uses, so somebody who chose Russian there keeps it
 * across the cutover — the cheapest possible continuity.
 *
 * Both functions tolerate a browser that refuses storage outright: private mode and blocked site
 * data make the accessor itself throw, and a visitor who cannot be remembered is not an error.
 */
export function rememberedLanguage(): string | null {
    try {
        return window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    } catch {
        return null;
    }
}

export function rememberLanguage(language: Language): void {
    try {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    } catch {
        // Nothing to do and nothing to report.
    }
}
